import { latest } from '@/mocks/content';

export default function LatestSection() {
  return (
    <section id="latest" className="scroll-mt-nav py-12 md:py-16 bg-background-100/60">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="flex items-end justify-between gap-4 flex-wrap">
            <div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 flex items-center gap-2">
                <i className="ri-time-line text-primary-500"></i>
                最新更新
              </h2>
              <p className="mt-2 text-sm text-foreground-600">
                近期整理补充的条目，适合已经看完热门榜、想再挖一点新东西的浏览者。
              </p>
            </div>
          </div>

          <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
            {latest.map((item) => (
              <a
                key={item.title}
                href="#collections"
                className="group flex items-center gap-3 md:gap-4 p-3 rounded-lg bg-background-50 border border-background-200 cursor-pointer transition-colors hover:border-primary-300"
              >
                <div className="w-28 h-[68px] md:w-32 md:h-20 flex-shrink-0 rounded-md overflow-hidden">
                  <img
                    src={item.cover}
                    alt={`${item.title} 缩略封面`}
                    title={`${item.title} - 91精选最新更新`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <h3 className="text-sm font-bold text-foreground-950 line-clamp-1 group-hover:text-primary-700 transition-colors">
                    {item.title}
                  </h3>
                  <div className="mt-2 flex items-center gap-2 text-xs text-foreground-600 flex-wrap">
                    <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900">
                      {item.categoryName}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-timer-line"></i>
                      {item.duration}
                    </span>
                  </div>
                </div>
                <span className="flex-shrink-0 text-xs text-foreground-500">{item.time}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}